
type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function storage(): Store | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

function keyOf(scope: string): string {
  return `chat-drafts:${scope}`;
}

function readAll(store: Store, scope: string): Record<string, string> {
  try {
    const raw = store.getItem(keyOf(scope));
    const parsed: unknown = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, string>) : {};
  } catch {
    return {};
  }
}

export function readDraft(scope: string, id: string, store: Store | null = storage()): string {
  if (!store) return '';
  const value = readAll(store, scope)[id];
  return typeof value === 'string' ? value : '';
}

export function writeDraft(scope: string, id: string, text: string, store: Store | null = storage()): void {
  if (!store) return;
  const all = readAll(store, scope);
  if (text.trim()) all[id] = text;
  else delete all[id];
  try {
    if (Object.keys(all).length === 0) store.removeItem(keyOf(scope));
    else store.setItem(keyOf(scope), JSON.stringify(all));
  } catch {
  }
}
